import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

const mutation = graphql`
  mutation LogoutUserMutation {
    logoutUser {
      id
    }
  }
`;

function commit(environment) {
  return new Promise((resolve, reject) => {
    commitMutation(environment, {
      mutation,
      variables: {},
      onCompleted: (response, errors) => {
        if (errors) {
          console.error('Logout mutation errors:', errors);
          reject(errors);
        } else {
          console.log('User logged out successfully');
          resolve(response);
        }
      },
      onError: (error) => {
        console.error('Logout mutation error:', error);
        reject(error);
      },
    });
  });
}

const LogoutUserMutation = { commit };
export default LogoutUserMutation;